import { Component, input, CUSTOM_ELEMENTS_SCHEMA, output } from '@angular/core';
import { PropertyGallery } from '../property-gallery/property-gallery';
import { PropertyInfo } from '../property-info/property-info';
import { Listing } from '../../dto';
import { SvgIconComponent } from 'angular-svg-icon';

@Component({
  selector: 'app-property-card',
  imports: [PropertyGallery, PropertyInfo, SvgIconComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  host: {
    class: 'block h-full',
  },
  templateUrl: './property-card.html',
})
export class PropertyCard {
  public readonly listing = input.required<Listing>();
  public readonly listingIndex = input.required<number>();
  public readonly triggerRefinePrompt = output<void>();
}
